import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React from "react";
import { SwissGermanLocale } from "../../../../data/constants";
import { ModuleSelectionViewModel } from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import TranslatedMessage from "../../../translations/TranslatedMessage";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import { UserSelectionRow } from "./UserSelectionRow";

type UserModuleSelectionProps = {
  modulesSelection: ModuleSelectionViewModel[];
  onModuleRemoved: (selection: ModuleSelectionViewModel) => void;
};

const UserModuleSelection: React.FunctionComponent<UserModuleSelectionProps> = ({
  modulesSelection,
  onModuleRemoved,
}) => {
  const data = useSignUpContext();

  let totalPrice = 0;

  const mappedRows = modulesSelection
    .map((selection, index) => {
      const examSession = data.availableExamSessions.find((e) => e.id === selection.examSessionId);
      const course = examSession?.courses.find((c) => c.id === selection.courseId);
      const module = course?.modules.find((m) => m.id === selection.moduleId);

      if (!(examSession && course && module)) {
        return null;
      }

      totalPrice += module.price;

      return (
        <UserSelectionRow
          key={index}
          examSessionId={examSession.id}
          examSessionKey={examSession.sessionKey}
          courseId={course.id}
          courseName={course.name}
          module={module}
          rowButtonAction={onModuleRemoved}
          disabled={selection.paid ?? false}
        />
      );
    })
    .filter((row) => row !== null);

  return (
    <Grid container item spacing={4}>
      <Grid item xs={12}>
        <Typography variant="body1">
          <TranslatedMessage id="startCertification.moduleSelectionStep.selectedModules" />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell width={20} />
                <TableCell>
                  <TranslatedMessage id="application.examLocationAndDate.moduleColumn" />
                </TableCell>
                <TableCell>
                  <TranslatedMessage id="application.userSelector.course" />
                </TableCell>
                <TableCell>
                  <TranslatedMessage id="application.userSelector.examSession" />
                </TableCell>
                <TableCell align="right">
                  <TranslatedMessage id="startCertification.moduleSelectionStep.priceColumn" />
                </TableCell>
                <TableCell width={30} />
              </TableRow>
            </TableHead>
            <TableBody>
              {mappedRows.length ? (
                <React.Fragment>
                  {mappedRows}
                  <TableRow>
                    <TableCell colSpan={4} />
                    <TableCell align="right">
                      <TranslatedMessage id="common.total" />:
                    </TableCell>
                    <TableCell align="right">
                      {totalPrice.toLocaleString(SwissGermanLocale, { minimumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </React.Fragment>
              ) : (
                <TableRow>
                  <TableCell colSpan={7}>
                    <TranslatedMessage id="application.userSelector.noSelectedModules" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default UserModuleSelection;
